<template>
  <div>
    <span class="legend-title" v-if="!compact && legends && legends.length > 0">{{ $t('Webportal.Legend') }}:</span>
    <div class="legend-list" v-if="legends && legends.length > 0">
      <legend-up-down-tick v-if="showTick" />
      <LegendItem v-for="legend in legends"
                  :key="legend.key"
                  :legend="legend"
                  v-if="showIndices" />
    </div>
  </div>
</template>

<script>
import { Snowflake } from 'lucide-vue-next';
import { mapGetters } from 'vuex';
import LegendItem from './LegendItem.vue';
import LegendUpDownTick from './LegendUpDownTick.vue';

export default {
  name: 'LegendList',

  components: {
    Snowflake,
    LegendItem,
    LegendUpDownTick
  },

  props: {
    mode: { type: String, default: 'matrix' },
    compact: { type: Boolean, default: true },
    showTick: { type: Boolean, default: true },
    showIndices: { type: Boolean, default: true },
  },

  computed: {
    ...mapGetters('clientData', ['indices']),
    legends() {
      return this.indices;
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.legend-title {
  font-size: 0.8125rem;
  color: var(--bs-secondary-color);
}
</style>
